import { useState } from "react";

import PropTypes from "prop-types";

import dataTrustpilot from "common/data/trustpilot/data.json";
import useResizeScreenModified from "common/hooks/useResizeScreenModified";

import Img from "components/atoms/Img";
import Link from "components/atoms/LinkRouter";
import Title from "components/atoms/Title";
import FormNewsLetter from "components/molecules/FormNewsletter";
import AboutUs from "components/organisms/AboutUs";
import Banner from "components/organisms/Banner";
import IndustryNewsInsights from "components/organisms/IndustryNewsInsights";
import OurPartners from "components/organisms/OurPartners";
import TrustpilotFeedBack from "components/organisms/TrustpilotFeedBack";

const VietNamTemplate = ({ posts, data }) => {
  const [companyName, setCompanyName] = useState("");

  const handleInput = (event) => {
    setCompanyName(event.target.value);
  };

  const handleSubmit = () => {
    window.location.href = `/onboarding/register?country_id=244&company_name=${companyName}`;
  };

  const [screen, setScreen] = useState("DESKTOP");

  useResizeScreenModified(setScreen);

  return (
    <>
      <section>
        {/* <BannerChristmas /> */}
        <Banner
          minHeightBanner="banner-min-h-600"
          title="Let's streamline your Vietnam business"
          description="We simplify your Vietnam company setup procedures and administrative tasks with tailor-made solutions and seamless experience."
          bgColor="bg-bbc-gradient-13 rotate-180 bg-[length:180%_180%] animate-[gradientAnimation_10s_ease_infinite]"
          leftClassName="relative mt-4 lg:mt-0 col-12 lg:col-6 xl:col-7 z-40"
          leftContent={
            <div className="mb-10 lg:mb-10">
              <div className="flex flex-col justify-between rounded-full py-1 pr-1 text-sm lg:h-[50px] lg:flex-row lg:bg-white">
                <div className="flex flex-grow items-center lg:px-4">
                  <input
                    id="ipt-company-name"
                    placeholder="Your company name"
                    className="mb-4 w-full truncate rounded-full bg-white px-4 py-2 outline-none lg:mb-0"
                    value={companyName}
                    onChange={handleInput}
                  />
                </div>
                <div className="lg:max-w-[237px]">
                  <button
                    onClick={() => handleSubmit()}
                    className="h-full w-full truncate rounded-full bg-bbc-primary py-2 px-6 text-base text-white"
                  >
                    Register Your Company
                  </button>
                </div>
              </div>
            </div>
          }
          rightClassName="static hidden lg:block lg:col-6 xl:col-5"
          rightContent={
            <>
              {screen === "DESKTOP" && (
                <Img
                  wrapper={{
                    className: "bbc-banner-image-bottom-0 banner-home-vn",
                  }}
                  className="w-full"
                  src="/assets/images/vn/banner-vn-home.png"
                  width={1059}
                  height={815}
                  alt="digital incorporation service in Vietnam"
                  priority={true}
                />
              )}
            </>
          }
          wave={
            <div className="relative">
              <Img
                src="/assets/images/wave/exclude-wave.svg"
                className="h-full w-full"
                width={1920}
                height={95}
                wrapper={{
                  className: "w-full h-full",
                }}
                alt="banner-img"
              />
            </div>
          }
        ></Banner>
      </section>
      <IndustryNewsInsights data={posts} />
      <AboutUs
        data={data?.dataAboutUs}
        bgImage="/assets/images/common/pexels-gradient.png"
      />
      <OurPartners />
      <section className="relative pt-10 lg:mb-0 lg:bg-bbc-brand-100 lg:pt-48 lg:pb-8">
        <Img
          className="absolute left-0 right-0 w-full"
          style={{ top: "-4px" }}
          src="/assets/images/wave/curve_home-wave.svg"
          width={1920}
          height={158}
          wrapper={{ className: "hidden lg:block" }}
          alt="wave3"
        />
        <div className="container">
          <Title
            text="Be Free From Corporate Hassles And Complexities"
            className="mb-6 text-center text-bbc-30px font-semibold capitalize text-bbc-brand-800 lg:text-left lg:text-bbc-40px"
          />
          <p className="text-center leading-bbc-26 text-bbc-gray lg:text-left">
            Discover our wide range of digital corporate services that helps you
            set your business for success and growth.
          </p>
          <div className="row mt-6 items-center lg:mt-10">
            <div className="col-1 hidden lg:block" />
            <div className="col-12 order-2 mt-6 lg:col-5 lg:order-0 lg:mt-0">
              <div>
                <Title
                  as="h3"
                  text="Company Formation"
                  className="mb-4 text-2xl font-semibold leading-9 text-bbc-brand-800 lg:mb-6 lg:text-bbc-30px"
                />
                <p className="mb-6 leading-bbc-26">
                  We utilize onboarding platforms to streamline your
                  incorporation process. We are here to make sure your journey
                  to incorporation stays efficient and enjoyable.
                </p>
                <div className="text-center lg:text-left">
                  <Link
                    href="/company-registration"
                    className="inline-block cursor-pointer rounded-[50px] border border-bbc-brand-500 py-2 px-6 font-semibold leading-bbc-26 text-bbc-brand-500 hover:bg-bbc-brand-500 hover:text-white"
                  >
                    Explore
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-12 text-center lg:col-6">
              <Img
                src="/assets/images/vn/company_formation-vn.png"
                width={540}
                height={541}
                alt="company-formation"
              />
            </div>
          </div>
          <div className="row mt-6 items-center lg:mt-10">
            <div className="col-12 text-center lg:col-6">
              <Img
                src="/assets/images/vn/home/business_accounts-vn-home.png"
                width={540}
                height={541}
                alt="business-accounts"
              />
            </div>
            <div className="col-12 lg:col-5">
              <div>
                <Title
                  as="h3"
                  text="Business Accounts"
                  className="mb-4 text-2xl font-semibold leading-9 text-bbc-brand-800 lg:mb-6 lg:text-bbc-30px"
                />
                <p className="mb-6 leading-bbc-26">
                  Business banking can be jarring for both new and veteran
                  business owners due to changing local laws and extensive
                  procedures. We provide banking consultancy services to help
                  you cut through all the confusion and make the right call for
                  your Vietnam business.
                </p>
                <div className="text-center lg:text-left">
                  <Link
                    href="/open-bank-account"
                    className="inline-block cursor-pointer rounded-[50px] border border-bbc-brand-500 py-2 px-6 font-semibold leading-bbc-26 text-bbc-brand-500 hover:bg-bbc-brand-500 hover:text-white"
                  >
                    Explore
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-1 hidden lg:block" />
          </div>
          <div className="row mt-6 items-center lg:mt-10">
            <div className="col-1 hidden lg:block" />
            <div className="col-12 order-1 mt-6 lg:col-5 lg:order-0 lg:mt-0">
              <div>
                <Title
                  as="h3"
                  text="Accounting & Auditing"
                  className="mb-4 text-2xl font-semibold leading-9 text-bbc-brand-800 lg:mb-6 lg:text-bbc-30px"
                />
                <p className="mb-6 leading-bbc-26">
                  Get trained professionals to balance your books, file accounts
                  and help you stay compliant with the latest regimes and
                  requirements prescribed in the Law on Accounting and the
                  Vietnam Accounting Standard.
                </p>
                <div className="text-center lg:text-left">
                  <Link
                    href="/accounting-and-auditing"
                    className="inline-block cursor-pointer rounded-[50px] border border-bbc-brand-500 py-2 px-6 font-semibold leading-bbc-26 text-bbc-brand-500 hover:bg-bbc-brand-500 hover:text-white"
                  >
                    Explore
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-12 text-center lg:col-6">
              <Img
                src="/assets/images/common/accounting_auditing-offshore_vn.png"
                width={540}
                height={541}
                alt="accounting-auditing"
              />
            </div>
          </div>
        </div>
      </section>
      <div className="mb-20 hidden lg:block">
        <Img
          className="w-full"
          src="/assets/images/wave/curve_home1-wave.svg.svg"
          width={1920}
          height={116}
          wrapper={{ className: "hidden lg:block" }}
          alt="wave4"
        />
      </div>
      <section>
        <div className="container">
          <div className="col-10 m-auto">
            <Title className="title-h2 mb-6 pb-0 text-center text-bbc-brand-800">
              Hear It From Our Valued Customers
            </Title>
            <p className="text-center">
              Clients talked about us on{" "}
              <a
                className="font-medium text-bbc-primary hover:text-bbc-secondary-300"
                target="_blank"
                rel="noreferrer"
                href="https://www.trustpilot.com/review/bbcincorp.com"
              >
                Trustpilot
              </a>
            </p>
            <TrustpilotFeedBack data={dataTrustpilot.feedback} />
          </div>
        </div>
      </section>
      <FormNewsLetter bgColor="bg-bbc-gradient-9" />
    </>
  );
};

export default VietNamTemplate;

VietNamTemplate.propTypes = {
  data: PropTypes.object,
  posts: PropTypes.array,
};

VietNamTemplate.defaultProps = {
  data: {},
  posts: [],
};
